import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';

let defaultStyles = {
    container: {
        height: Theme.playerFooterHeight,
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        paddingRight: 35,
        paddingLeft:20,
        width: '100%',
        marginBottom: 15
    },
    progressBar: {
        flex: 8
    },
    recordIcon: {
        marginEnd: 15,
        alignSelf: 'center'
    },
    icon: {
        width: 29,
        height: 29
    },
    iconsContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingRight: 15
    },
    iconRecordOffsetLeft: {
        paddingLeft: 15,
        paddingRight: 15
    }
};

if (Device.isTablet) {
    defaultStyles = {
        ...defaultStyles,
        container: {
            ...defaultStyles.container,
            marginBottom: 0
        }
    };
}

if (Device.isWeb) {
    defaultStyles = {
        ...defaultStyles,
        iconsContainer: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-end'
        },
        icon: {
            ...defaultStyles.icon,
            marginLeft: 10,
            marginRight:25
        }
    };
}

// Due to AirPlay component, styles needs to be wrapped like this
const airPlayStyles = StyleSheet.create({
    container: {},
    button: {
        display: 'none'
        // backgroundColor: 'green'
        // width: 37,
        // height: 37,
        // backgroundColor: 'red',
        // margin: 0
    }
});

export default StyleSheet.create(defaultStyles);

export { airPlayStyles };
